import * as React from 'react';
import { History } from 'history';
import Model from './section-model';
import BasePicklistCard from '../base/base-picklistcard.component';
import { direction } from '../../services/app.service';

interface IProps { 
  history: History;
  caption?: string;
  nodataCaption?: string;
  replaceText?: any;
  parentId?: number;
  tag?: string;
  seq?: number;
  eventId?: number;
  header?: any;
  pageSize?: number;
  swipe?: string;
  isFlipImage?: boolean;
  onLoad?: (data: any) => void;
  onLoadAll?: (data: any) => void;
  cardDirection?: direction;
  readOnly?: boolean;
  disablePagination?: boolean;
  disablePaginationButtonPage?: boolean;
  disablePaginationButtonPrev?: boolean;
  disableSearch?: boolean;
  disableCard?: boolean;
  disableCardChild?: boolean;
  children?: React.ReactNode;
}

interface IState {
  children: React.ReactNode;
  header: any;
}

export default class SectionPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      children: this.props.children,
      header: this.header(),
    }
  }

  private header() {
    const filter = (data: any) => { return {...data, ...this.props.header?.filter((d: any) => d.name === data.name)?.[0]} }
    return Model.columnPicklistCard.map((d: any) => d.type === 'children'? {...d, name: 'datarowSection', children: this.props.children} : filter(d));
  }
  
  private onLoad = (data: any) => {
    this.props.onLoad?.(data);
  }

  private onLoadAll = (data: any) => {
    if (this.props.onLoadAll) {
    } 
    console.log(data)
    let d = data?.filter((d: any) => !d.event || (d.event && !d.event?.enddate))?.[0];
    return this.props.pageSize === 1 && d && {dataset: [d], pageSize: 1};
  }

  public componentDidUpdate() {
    if (this.props.children !== this.state.children)
      this.setState({ header: this.header(), children: this.props.children });
  }
  
  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} caption={this.props.caption} id={this.props.parentId} nodataCaption={this.props.nodataCaption} endPointFilter={Model.endPointFilterList(this.props.parentId, this.props.tag, this.props.seq, this.props.eventId)} model={Model} header={this.state.header} searchField={this.props.disableSearch? ' ' : ''} replaceText={this.props.replaceText} cardDirection={ this.props.cardDirection} cardHeader={this.props.pageSize !== 1} cardCount={this.props.disableSearch? 1 : 0} cardBorderWidth={this.props.disableCardChild? 0 : 1} cardBoxShadow={this.props.children? 0 : 1} cardSpacing={1} cardCollapse={this.props.pageSize !== 1} swipe={this.props.disablePagination? '' : (this.props.swipe || (this.props.disableSearch? 'vertical' : 'horizontal'))} onLoad={this.onLoad} onLoadAll={this.onLoadAll} autoLoad={this.props.disablePagination} autoUnselect readOnly={this.props.readOnly} disablePagination={this.props.disablePagination} disablePaginationButtonPage={this.props.disablePaginationButtonPage} disablePaginationButtonPrev={this.props.disablePaginationButtonPrev} disableBackButton disableCard={this.props.disableCard} />
    );
  }
}
